import { HttpErrorResponse } from '@angular/common/http';
import { TimeoutError } from 'rxjs';

export const TIMEOUT_VALIDATION_ERROR =
  'La validación del archivo tardó demasiado. Intenta nuevamente o reduce el volumen de la planilla.';

export function fileTooLargeMessage(maxUploadBytes: number): string {
  const maxMb = Math.round(maxUploadBytes / (1024 * 1024));
  return `El archivo excede el tamaño máximo permitido (${maxMb} MB). Reduce el peso del archivo e inténtalo de nuevo.`;
}

export function backendErrorMessage(error: HttpErrorResponse): string {
  const body = error.error;
  if (typeof body === 'string') return body;
  if (body && typeof body === 'object') {
    const nested = body as { error?: { message?: string }; message?: string };
    return nested.error?.message ?? nested.message ?? '';
  }
  return error.message ?? '';
}

export function isFileTooLargeError(cause: unknown): boolean {
  if (!(cause instanceof HttpErrorResponse)) return false;
  return (
    cause.status === 413 ||
    /file too large/i.test(backendErrorMessage(cause)) ||
    cause.statusText === 'Payload Too Large'
  );
}

export function resolveStaffValidationError(
  cause: unknown,
  options: { maxUploadBytes: number; genericMessage: string },
): string {
  if (cause instanceof TimeoutError) return TIMEOUT_VALIDATION_ERROR;
  if (isFileTooLargeError(cause)) return fileTooLargeMessage(options.maxUploadBytes);
  return options.genericMessage;
}
